import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./Youreko.module.scss";
import { useEffect, useState } from "react";

import fetchEnergyLabels, {
  EnergyLabelsResponse,
} from "./data/EnergyLabelsFetcher";
import { Product } from "@/types/types";
import { useVariant } from "../../hooks/useVariant/useVariant";

type Props = {
  product: Product;
};

export function YourekoJL({ product }: Props) {
  const { variant } = useVariant(product);
  const [energyLabels, setEnergyLabels] = useState<EnergyLabelsResponse>({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetchEnergyLabels(product.sellingProductType || "", variant.title).then(
      (result) => {
        setEnergyLabels(result);
        setLoading(false);
      },
    );
  }, []);

  if (energyLabels.error) {
    return (
      <SecondaryButton className={styles.yourekoJL}>
        {energyLabels.error}
      </SecondaryButton>
    );
  }

  if (!energyLabels?.results) return null;

  const result = energyLabels.results[variant.title];

  if (!result) return null;

  return (
    <SecondaryButton className={styles.yourekoJL} submitting={loading}>
      {result.energyCostSaving} energy saving
    </SecondaryButton>
  );
}

export default YourekoJL;
